import { deviceTypes } from "../../constants/deviceTypes";
import { subscriptionStatus } from "../../constants/subscriptionStatus";

const SubscriptionDisplay = ({ status, type }) => {

    const SetSubscription = () => {
        if (type === deviceTypes.TraditionalDevice) {
            return <span className="text-success">Perpetual</span>
        }
        if (status === subscriptionStatus.Active) {
            return <span className="text-success">Active</span>
        }
        else if (status === subscriptionStatus.Expired) {
            return <span className="text-danger">Expired!</span>
        }
        else if (status === subscriptionStatus.Inactive) {
            return <span className="text-inactive">Inactive</span>
        }
        else {
            return <span>--</span>
        }
    }

    return (
        <>
            <SetSubscription />
        </>
    );
}

export default SubscriptionDisplay;